"use client";

import { useSignalREvent } from "@/lib/signalr/useSignalREvent";
import { SIGNALR_EVENTS } from "@/lib/signalr/events";
import type { CcofCardChangedEvent } from "@/lib/signalr/types";
import type { DeepPartial } from "@/lib/object";
import { useUpdatePatientSearchCache } from "@/features/patient/hooks/useUpdatePatientSearchCache";
import { CcofPatientSearchResult } from "lib/api-types/schemas";

function toPatientSearchPatch(
  patient: NonNullable<CcofCardChangedEvent["patient"]>,
): DeepPartial<CcofPatientSearchResult> {
  return {
    firstName: patient.firstName,
    lastName: patient.lastName,
    dateOfBirth: patient.dateOfBirth,
    mrn: patient.mrn,
    phoneNumber: patient.phoneNumber,
    cardBrand: patient.cardOnFile?.brand ?? null,
    cardLast4: patient.cardOnFile?.last4 ?? null,
  };
}

export function useCommandPaletteCardChangedEvent(): void {
  const updatePatientSearchCache = useUpdatePatientSearchCache();

  useSignalREvent<CcofCardChangedEvent>(
    SIGNALR_EVENTS.CCOF_CARD_CHANGED,
    (event) => {
      if (!event.patient?.patientId) return;

      updatePatientSearchCache(
        event.patient.patientId,
        toPatientSearchPatch(event.patient),
      );
    },
  );
}
